import React from "react";
import { Col, Form, Row } from "react-bootstrap";


const UpdateUserGroup = ({ userGroup, handleChangeForUpdateUser }) => {

const formatDateForInput = (isoDateString) => {
  const date = new Date(isoDateString);
  const formattedDate = date.toISOString().split('T')[0];
  return formattedDate;
};
   
  return (
    <>
      <Form>
        <Row>
          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>Program Name</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter Program Name"
                name="name"
                value={userGroup?.name}
                onChange={handleChangeForUpdateUser}
                required
              />
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>Start Date</Form.Label>
              <Form.Control
                type="date"
                name="startDate"
                value={formatDateForInput(userGroup?.startDate)}
                onChange={handleChangeForUpdateUser}
                required
              />
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>End Date</Form.Label>
              <Form.Control
                type="date"
                name="endDate"
                value={formatDateForInput(userGroup?.endDate)}
                onChange={handleChangeForUpdateUser}
                required
              />
            </Form.Group>
          </Col>
        </Row>
      </Form>
    </>
  );
};

export default UpdateUserGroup;
